import * as Yup from "yup";

const validationSchema = Yup.object({
  companyName: Yup.string().required("Company Name is required"),
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Email ID is required"),
  contactNo: Yup.string(),
  country: Yup.string().required("Country Name is required"),
});

export { validationSchema };
